import * as angular from "angular";
import {IController} from "angular";
import { Webhook } from '../../models/webhook.model';

export class webhooksTableController implements IController {

  webhooks: Webhook[];
  onRemove: Function;
  onEdit: Function;

  constructor() {}

}

angular
  .module('bringoz.admin.webhooks')
  .component('webhooksTable', {
    bindings: {
      webhooks: '<',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./webhooks-table.html').default,
    controller: webhooksTableController
  });
